import React from "react";
import Select from "react-select";

const MaritalStatusSelect = ({ value, onChange }) => {
  const mstatusOptions = [
    { value: 'single', label: 'Single' },
    { value: 'married', label: 'Married' },
  ];

  const handleChange = (selectedOption) => {
    onChange(selectedOption); // Pass the entire object
  };

  // Custom styles for the Select component
  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: '#f9f9f9', // Apply background color
      borderColor: '#ddd', // Apply border color
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999, // Ensure dropdown appears above other elements
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#666666', // Customize placeholder color
    }),
  };

  return (
    <Select
      options={mstatusOptions}
      placeholder="Select Marital Status"
      value={mstatusOptions.find(option => option.value === value?.value) || null} // Ensure value is null when not selected
      onChange={handleChange}
      styles={customStyles} // Apply custom styles here
    />
  );
};

export default MaritalStatusSelect;
